import { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { ActivityFormSchema } from '@/constants/formSchema/ActivityFormSchema';
import { EmployeeTypeEnum } from '@/types/ActivityData';
import { Option } from '@/types/Filter';

import SearchSelect from '../atoms/SearchSelect';
import TrashButton from '../atoms/TrashButton';

interface ActivityPoleConditionTrainingProps {
	poleIndex: number;
	conditionIndex: number;
	trainingIndex: number;
	employeeType: EmployeeTypeEnum;
	form: UseFormReturn<z.infer<typeof ActivityFormSchema>>;
	trainings: Option[];
	removeTraining: (index: number) => void;
}

const ActivityPoleConditionTraining = ({
	poleIndex,
	conditionIndex,
	trainingIndex,
	form,
	employeeType,
	trainings,
	removeTraining,
}: ActivityPoleConditionTrainingProps) => {
	const baseName =
		employeeType === EmployeeTypeEnum.INTERNAL
			? `internalData.activityPoles`
			: `thirdPartyData.activityPoles`;
	const [trainingSearch, setTrainingSearch] = useState('');
	const selectedTrainings = form
		.watch(`${baseName}.${poleIndex}.conditions.${conditionIndex}.trainings`)
		.map((el) => el.trainingId);

	const availableTrainings = trainings.filter(
		(el) =>
			!selectedTrainings.some(
				(selectedTraining, selectedIndex) =>
					selectedTraining === el.value && selectedIndex !== trainingIndex,
			),
	);
	const filteredTrainings =
		availableTrainings?.filter((el: Option) =>
			el.label.toLowerCase().includes(trainingSearch.toLowerCase()),
		) ?? [];

	return (
		<div className="flex items-center gap-2">
			<SearchSelect
				{...form.register(
					`${baseName}.${poleIndex}.conditions.${conditionIndex}.trainings.${trainingIndex}.trainingId`,
				)}
				control={form.control}
				title="Nome do Treinamento"
				options={filteredTrainings}
				required
				className="w-[35rem]"
				setSearch={(e) => setTrainingSearch(e)}
			/>
			<TrashButton
				onClick={() => removeTraining(trainingIndex)}
				color="action"
			/>
		</div>
	);
};

export default ActivityPoleConditionTraining;
